export default "__VITE_ASSET__KHKaXBBd__"